// export const apiURl = 'https://0qcfq0a71h.execute-api.us-east-1.amazonaws.com/dev';
export const apiURl = 'https://genai.aeonx.digital/dev';
// export const apiURl = 'http://10.201.1.174:5000/dev';
// export const apiURl = 'http://10.201.0.201:5001';
